// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoCarouselCard_root__zPPnx","cardContent":"VideoCarouselCard_cardContent__JoExz","icon":"VideoCarouselCard_icon__FQ_qP"};